import React from 'react';
import './ListProducts.css';
import ItemProduct from './ItemProducts';

const ListProducts = ({ products }) => {
  return (
    <div className="list-products">
      {products.length > 0 ? (
        products.map((product) => (
          <ItemProduct key={product.id} product={product} />
        ))
      ) : (
        <p>No hay productos disponibles.</p>
      )}
    </div>
  );
};

export default ListProducts;
